import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';


@Component({
    selector: 'LocationKPI',
    templateUrl: './LocationKPI.html',
})
export class LocationKPIComponent extends PageBase {

    constructor(el: ElementRef) {
        super(el, "OneWayAdmin");
    }
}
